import React from 'react';

const Advice = () => {
  return (
    <div>
      
    </div>
  );
}

export default Advice;
